import type { SVGProps } from "react";
const SvgIconInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <circle cx={497} cy={370} r={50} />
    <path d="M587 654h-50V498c0-13.81-11.19-25-25-25h-50c-13.81 0-25 11.19-25 25s11.19 25 25 25h25v131h-50c-13.81 0-25 11.19-25 25s11.19 25 25 25h150c13.81 0 25-11.19 25-25s-11.19-25-25-25" />
    <path d="M719.5 832h-415C242.47 832 192 781.53 192 719.5v-415c0-62.03 50.47-112.5 112.5-112.5h415c62.03 0 112.5 50.47 112.5 112.5v415c0 62.03-50.47 112.5-112.5 112.5m-415-615c-48.25 0-87.5 39.25-87.5 87.5v415c0 48.25 39.25 87.5 87.5 87.5h415c48.25 0 87.5-39.25 87.5-87.5v-415c0-48.25-39.25-87.5-87.5-87.5z" />
  </svg>
);
export default SvgIconInfo;
